import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackListEvent } from '@jetshop/core/analytics/tracking';
import AddonProductQuery from '../AddonProducts/AddonProductQuery.gql';
import { useQuery } from 'react-apollo';
import { theme } from '../../Theming/Theming';
import ProductGrid from '../../CategoryPage/ProductGrid';

const SparePartsWrapper = styled('div')`
  margin: 1rem 0 1rem 0;
  width: 100%;
  > h3 {
    margin: 1rem 0;
  }
  //SLIDER WIDTH
  .slider-items {
    > * {
      margin-right: 5%;
      ${theme.only.sm} {
        width: 50%;
      }
      ${theme.only.md} {
        width: 50%;
      }
      ${theme.only.lg} {
        width: 40%;
      }
      ${theme.above.xl} {
        width: 40%;
      }
    }
  }
`;

const SpareParts = ({ list }) => {
  const result = useQuery(AddonProductQuery, {
    variables: { articleNumbers: list },
    errorPolicy: 'all'
  });

  const products = result?.data?.products;

  //TRACK LIKE PRODUCTGRID
  const track = useTracker();
  useEffect(() => {
    // Dont track anything if there are no products to render
    if (!products || products.length === 0) return;
    // Otherwise track a list view event
    track(trackListEvent({ listName: 'Spare parts products', products }));
  }, [products, track]);

  if (!products) return null;

  return (
    <SparePartsWrapper id="spare-parts-wrapper">
      <ProductGrid products={products} listname="spare-parts" />
    </SparePartsWrapper>
  );
};

export default SpareParts;
